module.exports = __webpack_public_path__ + "img/hr-rock-medium-10.b328f20e.png";